import { render, staticRenderFns } from "./PencilEditIcon.vue?vue&type=template&id=3241be4c&"
import script from "./PencilEditIcon.vue?vue&type=script&lang=js&"
export * from "./PencilEditIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports